import { type IApiResponse, type IElectiveCategoryState } from '@/helpers/types';
import { getCommandQuery, type IGetQuery } from '@/store/actions/api-utils';

import { coreApiSlice } from '../apiSlice';

export const electiveCategoryApiSlice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getElectiveCategory: builder.query<
			IApiResponse<IElectiveCategoryState[]>,
			IGetQuery & { Name?: string | number; SortBy?: string }
		>({
			query: ({ paged, query, Name, SortBy }) => ({
				url: `/ElectiveCategory${getCommandQuery(paged, ...(query || []))}`,
				method: 'GET',
				body: { Name, SortBy },
			}),
		}),
		getElectiveCategoryById: builder.mutation<IApiResponse<IElectiveCategoryState>, { id: string }>({
			query: ({ id }) => ({
				url: `/ElectiveCategory/${id}`,
				method: 'GET',
			}),
		}),
	}),
});

export const { useGetElectiveCategoryQuery, useLazyGetElectiveCategoryQuery, useGetElectiveCategoryByIdMutation } =
	electiveCategoryApiSlice;
